import { AfterContentInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[rlAutofocus]',
})
export class AutofocusDirective implements AfterContentInit {
  constructor(private elementRef: ElementRef) {}

  public ngAfterContentInit(): void {
    this.elementRef.nativeElement.focus();
  }
}
